<template>
  <label :class="['ms-checkbox', { 'event-none': readOnly }]">
    <input
      type="checkbox"
      class="ms-checkbox__input"
      :readOnly="readOnly"
      :checked="isChecked"
      :value="isChecked"
      :disabled="disabled"
      v-on="listeners"
    >
    <span
      class="ms-checkbox__label"
    >
      <template v-if="label && isShowLabel">
        {{ label }}
      </template>
      <template v-else-if="$slots.default">
        <slot />
      </template>
    </span>
  </label>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { cancelEvent } from '@/components/utils/event'

export default defineComponent({
  name: 'MsCheckbox',
  emits: ['update:modelValue', 'change'],
  props: {
    /** v-model */
    modelValue: {
      default: false,
      type: [Boolean, Number, String],
    },
    /** label */
    label: {
      default: null,
      type: String,
    },
    /** Trạng thái checked */
    checked: {
      type: [Boolean, Number],
      default: false,
    },
    /** có hiển thị label ko? */
    isShowLabel: {
      type: Boolean,
      default: true,
    },
    /**
     * thuộc tính readOnly cho các form sử dụng có thể khai báo trực tiếp
     */
    readOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * Thuộc tính disable control (bổ sung lên đây để dùng chung cho toàn bộ các component)
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    // Variable
    let focused = false

    // Method
    const onFocus = () => {
      focused = true
    }
    const onBlur = () => {
      focused = false
    }

    // Event
    const listeners = computed(() => {
      return {
        input: () => {
          emit('update:modelValue', !props.modelValue)
        },
        change: (event) => {
          cancelEvent(event)
          emit('change', props.modelValue, props.label, event)
        },
        focus: (event) => {
          onFocus(event)
        },
        blur: (event) => {
          onBlur(event)
        },
      }
    })
    const isChecked = computed(() => props.modelValue || props.checked)

    return {
      focused,
      onFocus,
      onBlur,
      listeners,
      isChecked,
    }
  },
})
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCheckbox.scss';
</style>
